// extracted by mini-css-extract-plugin
export default {"inputWrapper":"rating_inputWrapper__f5nv8","titleRangeValue":"rating_titleRangeValue__rRr7L","titleRange":"rating_titleRange__+BAcT","inputRange":"rating_inputRange__QwDDE"};